export const prefix = "uiState";

const SHOW_SETTINGS_MODAL = `${prefix}:SHOW_SETTINGS_MODAL`;
const HIDE_SETTINGS_MODAL = `${prefix}:HIDE_SETTINGS_MODAL`;
const COLLAPSE_SAVED_FILTERS = `${prefix}:COLLAPSE_SAVED_FILTERS`;
const EXPAND_SAVED_FILTERS = `${prefix}:EXPAND_SAVED_FILTERS`;

const EXPAND_SEARCH_REPLACE = `${prefix}:EXPAND_SEARCH_REPLACE`;
const COLLAPSE_SEARCH_REPLACE = `${prefix}:COLLAPSE_SEARCH_REPLACE`;
const CHANGE_SEARCH_CASE_SENSITIVE = `${prefix}:CHANGE_SEARCH_CASE_SENSITIVE`;
const CHANGE_SEARCH_WHOLE_WORD = `${prefix}:CHANGE_SEARCH_WHOLE_WORD`;
const CHANGE_SEARCH_VALUE = `${prefix}:CHANGE_SEARCH_VALUE`;
const CHANGE_SEARCH_IN_FIELD = `${prefix}:TOGGLE_SEARCH_IN_FIELD`;

const SET_FILE_NAME = `${prefix}:SET_FILE_NAME`;

const SET_MENU_POPOVER_TYPE = `${prefix}:SET_MENU_POPOVER_TYPE`;

const SHOW_PRINT_PREVIEW_MODAL = `${prefix}:SHOW_PRINT_PREVIEW_MODAL`;
const HIDE_PRINT_PREVIEW_MODAL = `${prefix}:HIDE_PRINT_PREVIEW_MODAL`;

const SHOW_PREFERENCES_MODAL = `${prefix}:SHOW_PREFERENCES_MODAL`;
const HIDE_PREFERENCES_MODAL = `${prefix}:HIDE_PREFERENCES_MODAL`;

const SHOW_BACKUP_MODAL = `${prefix}:SHOW_BACKUP_MODAL`;
const HIDE_BACKUP_MODAL = `${prefix}:HIDE_BACKUP_MODAL`;

const SHOW_ABOUT_MODAL = `${prefix}:SHOW_ABOUT_MODAL`;
const HIDE_ABOUT_MODAL = `${prefix}:HIDE_ABOUT_MODAL`;

const SHOW_INSPECTOR_MODAL = `${prefix}:SHOW_INSPECTOR_MODAL`;
const HIDE_INSPECTOR_MODAL = `${prefix}:HIDE_INSPECTOR_MODAL`;

const SHOW_EXPORT_IMAGE_PREVIEW_MODAL = `${prefix}:SHOW_EXPORT_IMAGE_PREVIEW_MODAL`;
const HIDE_EXPORT_IMAGE_PREVIEW_MODAL = `${prefix}:HIDE_EXPORT_IMAGE_PREVIEW_MODAL`;

const SHOW_EXPORT_CSV_MODAL = `${prefix}:SHOW_EXPORT_CSV_MODAL`;
const HIDE_EXPORT_CSV_MODAL = `${prefix}:HIDE_EXPORT_CSV_MODAL`;

const SHOW_IMPORT_CSV_MODAL = `${prefix}:SHOW_IMPORT_CSV_MODAL`;
const HIDE_IMPORT_CSV_MODAL = `${prefix}:HIDE_IMPORT_CSV_MODAL`;

const SHOW_SAMPLE_MODAL = `${prefix}:SHOW_SAMPLE_MODAL`;
const HIDE_SAMPLE_MODAL = `${prefix}:HIDE_SAMPLE_MODAL`;

const SET_DEVICE_INSETS = `${prefix}:SET_DEVICE_INSETS`;

const SHOW_PURCHASE_MODAL = `${prefix}:SHOW_PURCHASE_MODAL`;
const HIDE_PURCHASE_MODAL = `${prefix}:HIDE_PURCHASE_MODAL`;

const SHOW_OPEN_FILE_MODAL = `${prefix}:SHOW_OPEN_FILE_MODAL`;
const HIDE_OPEN_FILE_MODAL = `${prefix}:HIDE_OPEN_FILE_MODAL`;

export const actionTypes = {
  SHOW_SETTINGS_MODAL,
  HIDE_SETTINGS_MODAL,
  SET_FILE_NAME,
  COLLAPSE_SAVED_FILTERS,
  EXPAND_SAVED_FILTERS,
  EXPAND_SEARCH_REPLACE,
  COLLAPSE_SEARCH_REPLACE,
  CHANGE_SEARCH_CASE_SENSITIVE,
  CHANGE_SEARCH_WHOLE_WORD,
  CHANGE_SEARCH_VALUE,
  CHANGE_SEARCH_IN_FIELD,
  SET_MENU_POPOVER_TYPE,
  SHOW_PRINT_PREVIEW_MODAL,
  HIDE_PRINT_PREVIEW_MODAL,
  SHOW_PREFERENCES_MODAL,
  HIDE_PREFERENCES_MODAL,
  SHOW_BACKUP_MODAL,
  HIDE_BACKUP_MODAL,
  SHOW_ABOUT_MODAL,
  HIDE_ABOUT_MODAL,
  SHOW_INSPECTOR_MODAL,
  HIDE_INSPECTOR_MODAL,
  SHOW_EXPORT_IMAGE_PREVIEW_MODAL,
  HIDE_EXPORT_IMAGE_PREVIEW_MODAL,
  SHOW_EXPORT_CSV_MODAL,
  HIDE_EXPORT_CSV_MODAL,
  SHOW_IMPORT_CSV_MODAL,
  HIDE_IMPORT_CSV_MODAL,
  SET_DEVICE_INSETS,
  SHOW_PURCHASE_MODAL,
  HIDE_PURCHASE_MODAL,
  SHOW_OPEN_FILE_MODAL,
  HIDE_OPEN_FILE_MODAL,
  SHOW_SAMPLE_MODAL,
  HIDE_SAMPLE_MODAL
};

const showSettingsModal = () => {
  return {
    type: SHOW_SETTINGS_MODAL
  };
};

const hideSettingsModal = () => {
  return {
    type: HIDE_SETTINGS_MODAL
  };
};

const collapseSavedFilters = () => {
  return {
    type: COLLAPSE_SAVED_FILTERS
  };
};

const expandSavedFilters = () => {
  return {
    type: EXPAND_SAVED_FILTERS
  };
};

const collapseSearchReplace = () => {
  return {
    type: COLLAPSE_SEARCH_REPLACE
  };
};

const expandSearchReplace = () => {
  return {
    type: EXPAND_SEARCH_REPLACE
  };
};

const changeSearchCaseSensitive = caseSensitive => {
  return {
    type: CHANGE_SEARCH_CASE_SENSITIVE,
    caseSensitive
  };
};

const changeSearchWholeWord = wholeWord => {
  return {
    type: CHANGE_SEARCH_WHOLE_WORD,
    wholeWord
  };
};

const changeSearchValue = value => {
  return {
    type: CHANGE_SEARCH_VALUE,
    value
  };
};

const changeSearchInField = (field, value) => {
  return {
    type: CHANGE_SEARCH_IN_FIELD,
    field,
    value
  };
};

const setMenuPopoverType = typeId => {
  return {
    type: SET_MENU_POPOVER_TYPE,
    typeId
  };
};

const showPrintPreviewModal = () => {
  return {
    type: SHOW_PRINT_PREVIEW_MODAL
  };
};

const hidePrintPreviewModal = () => {
  return {
    type: HIDE_PRINT_PREVIEW_MODAL
  };
};

const showPreferencesModal = () => {
  return {
    type: SHOW_PREFERENCES_MODAL
  };
};

const hidePreferencesModal = () => {
  return {
    type: HIDE_PREFERENCES_MODAL
  };
};

const showBackupModal = () => {
  return {
    type: SHOW_BACKUP_MODAL
  };
};

const hideBackupModal = () => {
  return {
    type: HIDE_BACKUP_MODAL
  };
};

const showAboutModal = () => {
  return {
    type: SHOW_ABOUT_MODAL
  };
};

const hideAboutModal = () => {
  return {
    type: HIDE_ABOUT_MODAL
  };
};

const showInspectorModal = () => {
  return {
    type: SHOW_INSPECTOR_MODAL
  };
};

const hideInspectorModal = () => {
  return {
    type: HIDE_INSPECTOR_MODAL
  };
};

const showExportImagePreviewModal = () => {
  return {
    type: SHOW_EXPORT_IMAGE_PREVIEW_MODAL
  };
};

const hideExportImagePreviewModal = () => {
  return {
    type: HIDE_EXPORT_IMAGE_PREVIEW_MODAL
  };
};

const showExportCsvModal = () => {
  return {
    type: SHOW_EXPORT_CSV_MODAL
  };
};

const hideExportCsvModal = () => {
  return {
    type: HIDE_EXPORT_CSV_MODAL
  };
};

const showImportCsvModal = () => {
  return {
    type: SHOW_IMPORT_CSV_MODAL
  };
};

const hideImportCsvModal = () => {
  return {
    type: HIDE_IMPORT_CSV_MODAL
  };
};

const showSampleModal = () => {
  return {
    type: SHOW_SAMPLE_MODAL
  };
};

const hideSampleModal = () => {
  return {
    type: HIDE_SAMPLE_MODAL
  };
};

const setDeviceInsets = insets => {
  return {
    type: SET_DEVICE_INSETS,
    insets
  };
};

const showPurchaseModal = () => {
  return {
    type: SHOW_PURCHASE_MODAL
  };
};

const hidePurchaseModal = () => {
  return {
    type: HIDE_PURCHASE_MODAL
  };
};

const showFileVersionTooLowModal = allowReadonly => {
  return {
    type: SHOW_OPEN_FILE_MODAL,
    allowReadonly
  };
};

const hideFileVersionTooLowModal = () => {
  return {
    type: HIDE_OPEN_FILE_MODAL
  };
};

const setFileName = name => {
  return {
    type: SET_FILE_NAME,
    name
  };
};

export default {
  showSettingsModal,
  hideSettingsModal,
  collapseSavedFilters,
  expandSavedFilters,
  collapseSearchReplace,
  expandSearchReplace,
  changeSearchCaseSensitive,
  changeSearchWholeWord,
  changeSearchValue,
  changeSearchInField,
  setMenuPopoverType,
  showPrintPreviewModal,
  hidePrintPreviewModal,
  showPreferencesModal,
  hidePreferencesModal,
  showBackupModal,
  hideBackupModal,
  showAboutModal,
  hideAboutModal,
  showInspectorModal,
  hideInspectorModal,
  showExportImagePreviewModal,
  hideExportImagePreviewModal,
  showExportCsvModal,
  hideExportCsvModal,
  showImportCsvModal,
  hideImportCsvModal,
  setDeviceInsets,
  showPurchaseModal,
  hidePurchaseModal,
  showFileVersionTooLowModal,
  hideFileVersionTooLowModal,
  showSampleModal,
  hideSampleModal,
  setFileName
};
